import { createActionTypes } from '../../shared/actions';
import { failedNotIncluded } from '../../shared/utils';
import { ACTIONS_NAMESPACE } from '../../shared/constants';

export const typeChangePassword = 'CHANGE_PASSWORD';
export const typeLogout = 'LOGOUT';

export const namespace = `${ACTIONS_NAMESPACE}/TopNavbar`;

const changePassword = createActionTypes(typeChangePassword, namespace);

const logout = createActionTypes(typeLogout, namespace, {
  ...failedNotIncluded
});

export default {
  ...changePassword,
  ...logout
};



// WEBPACK FOOTER //
// ./src/containers/TopNavbar/constants.js